import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const LIBELLES_COULEURS = {
  bg: "Fond de page", glow: "Lueur", surface: "Surface des cartes", "surface-2": "Surface secondaire", line: "Lignes",
  ink: "Texte", muted: "Texte secondaire", accent: "Accent", "accent-ink": "Texte sur accent", micro: "Micro (assistant)",
  "micro-ink": "Icône du micro", danger: "Danger", success: "Succès",
};

export const ChampCouleur = ({ cle, valeur, onChange }) => (
  <div className="at-soft p-2.5 flex items-center gap-3" data-testid={`theme-color-field-${cle}`}>
    <input type="color" value={valeur} onChange={(e) => onChange(e.target.value.toUpperCase())} aria-label={LIBELLES_COULEURS[cle]}
      className="w-11 h-11 shrink-0 cursor-pointer border-0 bg-transparent p-0" data-testid={`theme-color-picker-${cle}`} />
    <span className="min-w-0 flex-1">
      <span className="block text-sm font-semibold truncate">{LIBELLES_COULEURS[cle]}</span>
      <input value={valeur} onChange={(e) => onChange(e.target.value)} maxLength={7} spellCheck={false} aria-label={`Code ${LIBELLES_COULEURS[cle]}`}
        className="w-full bg-transparent outline-none text-sm at-muted uppercase min-h-[44px] -my-2.5" data-testid={`theme-color-hex-${cle}`} />
    </span>
  </div>
);

export const ChampRayon = ({ label, valeur, onChange, max = 40, testId }) => {
  const n = parseInt(valeur, 10) || 0;
  return (
    <label className="at-soft p-3 block" data-testid={testId}>
      <span className="flex justify-between text-sm font-semibold mb-1"><span>{label}</span><span className="at-muted">{valeur}</span></span>
      <input type="range" min={0} max={max} value={Math.min(n, max)} onChange={(e) => onChange(`${e.target.value}px`)} className="w-full min-h-[44px]" style={{ accentColor: "var(--accent)" }} />
    </label>
  );
};

export const ChoixSimple = ({ label, valeur, options, onChange, testId }) => (
  <label className="block">
    <span className="at-label block mb-1.5">{label}</span>
    <Select value={valeur} onValueChange={onChange}>
      <SelectTrigger className="at-input border-0 shadow-none" data-testid={testId}><SelectValue /></SelectTrigger>
      <SelectContent className="at-popover max-h-72">
        {options.map((o) => <SelectItem key={o.valeur} value={o.valeur} className="min-h-[44px] rounded-xl" style={o.style} data-testid={`${testId}-option-${o.valeur.replace(/[^a-zA-Z0-9]/g, "")}`}>{o.label}</SelectItem>)}
      </SelectContent>
    </Select>
  </label>
);

export const Section = ({ titre, children }) => (
  <section className="at-card p-4 md:p-5">
    <h3 className="font-bold mb-3">{titre}</h3>
    {children}
  </section>
);
